import { Alert, Card, LoadingOverlay, Title } from "@mantine/core";
import React from "react";
import {
  useGetProjectByProjectIdChecklistAndChecklistIdPartsQuery,
  usePostProjectByProjectIdChecklistAndChecklistIdOtherAttributesConfigAddMutation,
  usePostProjectByProjectIdChecklistAndChecklistIdOtherAttributesConfigUpdateMutation,
  usePostProjectByProjectIdChecklistAndChecklistIdOtherAttributesConfigUpdateorderMutation,
} from "../../../../../openapi";
import FoldableSection from "../../../../components/FoldableSection/FoldableSection";
import OtherAttributesConfig from "../../../../components/OtherAttributes/OtherAttributesConfig/OtherAttributesConfig";
import { useAppSelector } from "../../../../hooks";
import "../checklistapi.enhance";

type Props = { projectId: string; checklistId: string };

const ChecklistOtherAttributesSettings = (props: Props) => {
  const isProduction = useAppSelector((state) => state.globalReducer.isProduction);
  // Fail closed while the environment is loading, including for developers in PROD.
  if (isProduction !== false) return null;
  return <ChecklistOtherAttributesSettingsContent key={props.checklistId} {...props} />;
};

const ChecklistOtherAttributesSettingsContent = ({ projectId, checklistId }: Props) => {
  const args = { projectId, checklistId };
  const { data, isLoading, isError: loadError } = useGetProjectByProjectIdChecklistAndChecklistIdPartsQuery(args);
  const [add, addState] = usePostProjectByProjectIdChecklistAndChecklistIdOtherAttributesConfigAddMutation();
  const [update, updateState] = usePostProjectByProjectIdChecklistAndChecklistIdOtherAttributesConfigUpdateMutation();
  const [updateOrder, orderState] =
    usePostProjectByProjectIdChecklistAndChecklistIdOtherAttributesConfigUpdateorderMutation();
  const isSaving = addState.isLoading || updateState.isLoading || orderState.isLoading;
  const isError = loadError || addState.isError || updateState.isError || orderState.isError;

  return (
    <FoldableSection storageKey="checklist-other-attributes-settings">
      <FoldableSection.Header>
        <Title order={6}>Egne attributter</Title>
      </FoldableSection.Header>
      <FoldableSection.Body>
        <Card pos="relative" w="100%" bg="#f8f9fa" bd="1px solid var(--mantine-color-warmgray-2)">
          <LoadingOverlay visible={isLoading || isSaving} />
          {isError && (
            <Alert color="red" mb="sm">
              Kunne ikke laste eller lagre attributtene. Prøv igjen.
            </Alert>
          )}
          {data?.checklist && (
            <OtherAttributesConfig
              otherAttributesConfig={data.checklist.otherAttributesConfig ?? {}}
              allowFormulas={false}
              enableDropdownOptionDescriptions
              onAdd={(config) => add({ ...args, body: { otherAttributesConfigItemProps: config } })}
              onEdit={(config, key) =>
                update({ ...args, body: { otherAttributeConfigKey: key, otherAttributeConfigItemProps: config } })
              }
              onUpdateOrder={(idsInOrder) => updateOrder({ ...args, body: { idsInOrder } })}
            />
          )}
        </Card>
      </FoldableSection.Body>
    </FoldableSection>
  );
};

export default ChecklistOtherAttributesSettings;
